module.exports = __webpack_public_path__ + "static/img/9.e5d3407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/9.jpg
// module id = rXRg
// module chunks = 1